module.exports = __webpack_public_path__ + "static/media/allgaier-drum-drier-s.7214ba5f.jpg";